import { ComponentPropsWithoutRef, ElementType } from "react";
import * as styles from "./SectionBlockStatsAlt.css";
import Grid from "~/components/globals/Grid";
import { Heading } from "~/components/elements/Heading";
import { Paragraph } from "~/components/elements/Paragraph";

/** Resolved shape from GROQ (items[] -> { title, text }) */
export type SectionBlockStatsAltResolved = {
  _type: "sectionBlockStatsAlt";
  items?: Array<{ title?: string; text?: string }>;
};

export type SectionBlockStatsAltProps = ComponentPropsWithoutRef<"div"> & {
  data: SectionBlockStatsAltResolved;
  stats?: { value: number; label: string; icon?: ElementType }[];
};

export const SectionBlockStatsAlt = ({
  data,
  ...props
}: SectionBlockStatsAltProps) => {
  const { items } = data;

  return (
    <section>
      <Grid {...props} className={styles.grid}>
        <div {...props} className={styles.container}>
          {items?.map((item, index) => {
            return (
              <div style={{ display: "contents" }} key={index}>
                <div className={styles.item}>
                  <Heading as="h3" size="xl" className={styles.title} uppercase>
                    {item.title}
                  </Heading>
                  <Paragraph size="smMd" className={styles.text}>
                    {item.text}
                  </Paragraph>
                </div>
                {index < items.length - 1 && (
                  <div className={styles.divider}></div>
                )}
              </div>
            );
          })}
        </div>
      </Grid>
    </section>
  );
};
